module.exports = __webpack_public_path__ + "img/genexR.b6a187a8.png";